'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

const CarouselContext = React.createContext({
    activeIndex: 0,
    prevIndex: 0,
    totalSlides: 0,
    slides: null,
    firstSlideChangeOccurred: false,
    nextSlide: () => {},
    prevSlide: () => {},
    goToSlide: () => {},
});

export default CarouselContext;
